import { CookieService } from './cookies';

$(() => {
    const gdprIn = $('[data-gdpr-in]');
    const gdprBanner = $('[data-gdpr-banner]');

    if (!CookieService.IsGdprAccepted()) {
        gdprBanner.show();
    }

    gdprIn.click(() => {
        CookieService.SetGdprCookie('true');
        gdprBanner.hide();
    });
});
